<div
  [routerLink]="link"
  routerLinkActive="active"
  [routerLinkActiveOptions]="{ exact: true }"
  class="sidebar-item"
  [class.sidebar-item--no-hover]="disableHover"
>
  <app-icon [name]="icon" [size]="IconSize.Medium"></app-icon>
  <span class="sidebar-item__label" *ngIf="isExpanded">{{ 'sidebar.' + label | translate }}</span>
</div>

  
